export enum Routes {
  EntryPointView = 'EntryPointView',
  KillSwitchView = 'KillSwitchView',
  AuthenticationView = 'AuthenticationView',
  NotificationView = 'NotificationView',
  OnboardingView = 'OnboardingView',
  WhichDeviceView = 'WhichDeviceView',
  UserPickerView = 'UserPickerView',
  AddChildView = 'AddChildView',
  WalletView = 'WalletView',
  WalletViewHTML = 'WalletViewHTML',
  AllWalletViewsHTML = 'AllWalletViewsHTML',
  ScreenShot1 = 'ScreenShot1',
  ScreenShot0 = 'ScreenShot0',
  ScreenShot2 = 'ScreenShot2',
  ScreenShot3 = 'ScreenShot3',
  EnvironmentEditor = 'EnvironmentEditor',
  BlocklyWalletEditor = 'BlocklyWalletEditor',
  BlocklyWalletEditorPreview = 'BlocklyWalletEditorPreview',
  TokenScreenshot = 'TokenScreenshot',
  Majblomman = 'Majblomman'
}

export enum LinkType {
  Load = 'load'
}

export enum LinkCapability {
  Connect = 'connect',
  Send = 'send',
  Receive = 'receive',
  Request = 'request',
  Payment = 'payment',
  Gift = 'gift',
  Install = 'install'
}

export enum Platform {
  android = 'android',
  ios = 'ios',
  web = 'web',

  updateApp = 'update_app',
  userInfo = 'user_info'
}

export enum PushToken {
  NotSet = 'none',
  Rejected = 'rejected',
  Error = 'error'
}

export enum SaveKey {
  UUID = 'uuid',
  DeviceId = 'deviceId',
  DeviceState = 'state',
  DevicePushToken = 'devicePushToken',
  UserRoom = 'userCurrentRoom_',
  SelectedVaultId = 'selectedVaultItem',
  DebugSetting = 'debugSetting:',
  LastActiveUser = 'lastActiveUser',
  FeatureState = 'featureState',
  DownloadSource = 'downloadSource',
  OpenSource = 'openSource',
  Language = 'language',
  SelectedContact = 'selectedContact',
  BlocklyJSON = 'blocklyJSON',
  BlocklyEditorSplitplaneSizes = 'blocklyEditorSplitplaneSizes',
  IncomingLinkInQueue = 'IncomingLinkInQueue',
  OpenWalletContact = 'OpenWalletContact',
  WalletOfflineState = 'walletofflineState'
}

export enum SettingKey {
  VaultStyle = 'vaultStyle',
  WalletFaceId = 'walletFaceId',
  SaveRoomHeroAssetId = 'saveRoomHeroAssetId',
  SaveRoomLaserActive = 'saveRoomLaserActive',
  InviteChildHandled = 'inviteChildHandled',
  GuideCombine = 'guideCombine',
  GuideDivide = 'guideDivide',
  InviteChild = 'inviteChild',
  GuideWelcome = 'guideWelcome',
  GuideTopUp = 'guideTopUp',
  GuideTopUpDone = 'guideTopUpDone',
  GuideSwappedUser = 'guideSwappedUser',
  GuideTransfer = 'guideTransfer',
  GuideTransferSend = 'guideTransferSend',
  GuideTransferCompleted = 'guideTransferCompleted',
  GuideOpenChildCompleted = 'guideOpenChildCompleted',
  GuideNewChild = 'guideNewChild',
  HasReceivedInitialBalance = 'hasReceivedInitialBalance',
  HasPutCoinInSaveRoom = 'hasPutCoinInSaveRoom',
  AppShareTimeStamp = 'appShareTimeStamp',
  AppReviewTimeStamp = 'appReviewTimeStamp',
  NewsItemRead = 'newsItemRead',
  LastStartInfo = 'lastStartInfo'
}

export enum DebugFlag {
  Render = 'wallet-render',
  RenderDownscale = 'wallet-render-downscale',
  Physics = 'wallet-physics',
  Log = 'log',
  ShowLog = 'showLog',
  MuteAudio = 'audio-mute',
  ChildDevice = 'child-device',
  FasterCoinMaterial = 'faster-coin-material',
  DoubleTapToZoom = 'double-tap-to-zoom',
  TestHeartTing = 'testHeartTing',
  TestEphemeralTools = 'testEphemeralTools',
  TestIncoming = 'testIncoming',
  ShowRemoveButton = 'show-remove-button',
  ShowAllTopUpOptions = 'show-all-topup-options',
  ShowExperimentThemes = 'show-eperiment-themes',
  UnlockAllWallets = 'unlockAllWallets',
  UseFakeNewsData = 'useFakeNewsData',
  OfflineStart = 'offlineStart',

  // feature flags
  LocalFlagOnly = 'localFlagOnly',
  XmasWallets = 'xmasWallets',
  MoneyReveal = 'moneyReveal',
  CreateEmojis = 'createEmojis',
  NewsTokens = 'newsTokens',
  RemoveWalletFace = 'removeWalletFace'
}

export const DEFAULT_WALLET_FACE_ID = 'studio_blue'
export const DEFAULT_PROFILE_IMAGE = './images/wallet-skins/studio_blue.png'
export const DEFAULT_CONTACT_ICON = './images/wallet-contact-icons/studio_blue.png'
export const DEFAULT_PROFILE_THUMBNAIL = './images/wallet-skins-thumbnail/studio_blue.png'
export const DEFAULT_LANG = String('en')

export enum StaticTubeId {
  Tjing = 'tjing',
  Remove = 'remove'
}

export enum ShortcutDestination {
  Theme = 'theme',
  Scanner = 'scanner',
  TopUp = 'topup'
}
